import React from "react"
import "./DataAnalytics.css"
import "./general.css"
import Navbar from "../Navbar/Navbar"
//import { online } from "../../dummydata"
//import { FaEdgeLegacy } from "react-icons/fa";

const DataAnalytics = () => {
  return (
    <>
    <Navbar/>
   <div className="section home wf-section data-analytcs">
    <div className="flex-container flex-on-tablet w-container">
      <div className="text-content light narrow">
       <h1 className="first-title white">Data Analytics</h1>
     </div>

     <div className=" non-hide">
      <div className="container" id="request">
        

        </div>
      </div>
    </div>
  </div>
   


<div className="page-wrap">
  <div className="section wf-section">
    <div className="course-columns">
      <div className="sticky-column">
        <div className="nav-holder"><a href="#introduction" className="course-nav-button w-inline-block t-content">
          <div>Introduction</div>
          </a><a href="#program" className="course-nav-button w-inline-block t-content">
          <div>Program Summary</div>
          </a><a href="#career" className="course-nav-button w-inline-block t-content">
          <div>Career Opportunities</div>
          </a><a href="#requirements" className="course-nav-button w-inline-block t-content">
          <div>Course Content</div>
          </a><a href="#course_content" className="course-nav-button w-inline-block t-content">
          <div>Requirements</div>
         
          </a></div>
        <a href="/apply-data-analytics" className="button full-width top-padding w-button c-buuton">APPLY NOW</a>
      </div>
      

      <div className="course-content">
        <div id="introduction" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Program Highlights</h2>
            <ul>
                 <li><span class="semi-bold offset-padding">Course Curriculum :</span> <span class="bold">Certificate Program</span></li>

                <li><span className="semi-bold offset-padding">Duration :</span><span className="bold"> 3 Months</span></li>
                <li><span className="semi-bold offset-padding">Format :</span><span className="bold"> (Online/ In- person) </span></li>
                <li><span className="semi-bold offset-padding">Center :</span> <span className="bold"> Tema Mataheko</span> </li>
            </ul>
          </div>
        </div>
        <div id="introduction" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Introduction</h2>
			<p className="paragraph-2"> students will learn how to use programming languages such as R or Python to perform data analysis tasks. They will also learn how to work with different data sources, including structured 
            and unstructured data.
            </p>
			<p className="paragraph-2">The course may cover topics such as descriptive statistics, probability theory, hypothesis testing, 
            regression analysis, clustering, and classification. Students will learn how to use different tools and 
            libraries for data analysis, such as Pandas, NumPy, Matplotlib, and Scikit-learn.</p>
			<p className="paragraph-2">The skills learned in a data analysis course are highly sought after in various industries, including finance, 
            healthcare, marketing, and technology. Data analysis is a critical component of decision-making 
            processes and can help businesses improve their operations and bottom line.
            </p>
	
            
			</div>
        </div>
      
        <div id="program" className="group">
          <div className="text-content centered">
            <h2 className="second-title">Program Summary</h2>
            <p className="paragraph">
				<ul>
					<li className="">Introduction to Data Analysis</li>
					<li className="">Data Collection and Cleaning</li>
					<li className="">Exploratory Data Analysis (EDA)</li>
					<li className="">Statistical Foundations</li>
					<li className="">Data Preprocessing</li>
					<li className="">Introduction to Python and Python Programming</li>
					<li className="">Python for Data Analysis</li>
				</ul>
			</p>
			<p>If you are new to IT and wish to analyze data for businesses or brands, this is the course for you.</p>
          </div>
        </div>
        
        <div id="career" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Career Opportunities</h2>
            <p className="paragraph">
			<ul>
        <li>Data Analyst</li>
				<li>Data Scientist</li>
				<li>Business Intelligence Analyst</li>
				<li>Data Engineer</li>
				<li>Data Visualization Specialist</li>
				<li>Market Research Analyst</li>
				<li>Data Privacy and Security Specialist</li>
				
			</ul>
            </p>
           
          </div>
        </div>
        <div id="course_content" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Course Content</h2>
            <p className="paragraph">
            <div className="container inner_content_block2" id="inner_content_block2">

				<div className="row margin-bottom30 ">
					<div className="col-md-6 ">
						<ul>
						<li>Overview of Data Analysis: Definition, importance, and applications.</li>
						<li>Introduction to Data Analysis process and lifecycle</li>
						<li>Understanding data types: Categorical, numerical, and ordinal</li>
						<li>Data sources and collection methods</li>
						<li>Data cleaning techniques</li>
						<li>Probability theory: Basic concepts and calculations</li>
						</ul>
					</div>
					<div className="col-md-6">
						<ul>
							<li>Feature scaling: Normalization and standardization</li>
							<li>Feature encoding: One-hot encoding, label encoding</li>
							<li>Handling categorical variables: Dummy coding, ordinal encoding</li>
							<li>Regression analysis: Linear regression, multiple regression</li>
							<li>Introduction to python programming</li>
							<li>Analyzing data with Python</li>
						</ul>
					</div>
				</div>
				
				
			</div>
			</p>
          </div>
        </div>
		
        <div id="requirements" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Eligibility Requirements</h2>
			<ul>
				<li>Minimum of Basic Education Certificate</li>
			</ul>
           
        </div>
        <div id="admissions" className="group ">
          
          <a href="/apply-data-analytics" className="button full-width top-padding w-button c-buuton">APPLY NOW</a></div>
        </div>
      </div>
    </div>
  </div>
</div>

            
    </>
  )
}

export default DataAnalytics;
